/**
 * Created by marcio on 13/12/16.
 */

import Vue from 'vue'

const bus = new Vue();

export default bus